import { render, staticRenderFns } from "./NotMemberIndex.vue?vue&type=template&id=20c262e0&"
import script from "./NotMemberIndex.vue?vue&type=script&lang=js&"
export * from "./NotMemberIndex.vue?vue&type=script&lang=js&"
import style0 from "./NotMemberIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports